<div class="toggle-extension-groups-modal">
  <div class="toggle-extension-groups-modal__header">
    <pdq-heading element="h3">{{ extensionName }}</pdq-heading>
    <div class="toggle-extension-groups-modal__header-toggle">
      <span class="toggle-extension-groups-modal__enabled-label">Enabled</span>
      <pdq-slide-toggle [defaultValue]="enabled" (onToggle)="onToggleEnabled($event)"></pdq-slide-toggle>
    </div>
  </div>
  <div class="toggle-extension-groups-modal__content" [class.disabled]="!enabled">
    <span class="toggle-extension-groups-modal__description">
      The selected extension appears in the groups below. Enabling a group will activate the extension for that group.
    </span>
    <div class="toggle-extension-groups-modal__select-all-row">
      <pdq-checkbox
        [checked]="allSelected"
        [variant]="isIndeterminate ? 'indeterminate' : 'hyper'"
        [disabled]="!enabled"
        (click)="$event.stopPropagation()"
        (onChange)="onSelectAll($event)">
      </pdq-checkbox>
      <span class="toggle-extension-groups-modal__selected-count">{{ selectedCount }} Selected</span>
    </div>
    <div class="toggle-extension-groups-modal__groups-list">
      @for (group of groupSelections; track group.groupId; let i = $index) {
      <div
        class="toggle-extension-groups-modal__group-item"
        [class.toggle-extension-groups-modal__group-item--selected]="group.selected"
        (click)="onToggleGroup(i)">
        <pdq-checkbox
          [checked]="group.selected"
          [disabled]="!enabled"
          (click)="$event.stopPropagation()"
          (onChange)="onToggleGroup(i)">
        </pdq-checkbox>
        <span class="toggle-extension-groups-modal__group-name">{{ group.groupName }}</span>
      </div>
      }
    </div>
  </div>
  <div class="toggle-extension-groups-modal__actions">
    <pdq-button variant="light" label="Cancel" (onClick)="onCancel()"></pdq-button>
    <pdq-button variant="primary" label="Save" (onClick)="onSave()"></pdq-button>
  </div>
</div>
